import { ZmMessageBox } from '@zoom/zoom-ui-vue3';

import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';
import { translation } from '@/plugins/i18n';

const mergeOptions = (title, message, options = {}) => {
  if (!title && message) {
    options.customClass = options.customClass || 'only-message-message-box';
  } else if (title && !message) {
    options.customClass = options.customClass || 'only-title-message-box';
  }

  return options;
};

const BillingMessageBox = function (options, appContext = null) {
  if (typeof options === 'string') {
    return ZmMessageBox(options, appContext);
  } else {
    return ZmMessageBox(mergeOptions(options.title, options.message, options), appContext);
  }
};

BillingMessageBox.alert = (message, title, options = {}, appContext) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  // vueui 3 <==> vueui 2 compatibility: vueui2 default 'confirm', vueui3 default 'ok'
  if (!options.confirmButtonText) {
    options.confirmButtonText = translation('billing.common.confirm');
  }

  emit(EVENT_TYPES.UI_GLOBAL_ALERT, {
    type: 'alert',
    message: [title, message].filter((message) => !!message),
  });

  return new Promise((resolve, reject) => {
    ZmMessageBox.alert(message, title, mergeOptions(title, message, options), appContext)
      .then((resolvedReason) => {

        emit(EVENT_TYPES.UI_GLOBAL_ALERT_CLICK_CTA, {
          ctaText: options.confirmButtonText,
          type: 'alert',
          message: [title, message].filter((message) => !!message),
        });

        resolve(resolvedReason);
      })
      .catch((rejectReason) => {
        // console.log(rejectReason);
        // emit(EVENT_TYPES.UI_GLOBAL_ALERT_CLICK_CTA, {
        //   ctaText: rejectReason,
        //   type: 'alert',
        //   message: [title, message].filter((message) => !!message)
        // });
        reject(rejectReason);
      });
  });
};

BillingMessageBox.confirm = (message, title, options = {}, appContext) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  // vueui 3 <==> vueui 2 compatibility: vueui2 default 'confirm', vueui3 default 'ok'
  if (!options.confirmButtonText) {
    options.confirmButtonText = translation('billing.common.confirm');
  }

  return ZmMessageBox.confirm(message, title, mergeOptions(title, message, options), appContext);
};

BillingMessageBox.install = (app) => {
  BillingMessageBox._context = app._context;
  ZmMessageBox._context = app._context;
  app.config.globalProperties.$alert = BillingMessageBox.alert;
  app.config.globalProperties.$confirm = BillingMessageBox.confirm;
};
export default BillingMessageBox;
